import React, {useState,useEffect,useContext} from "react";
import { useTranslate } from 'react-redux-multilingual'
import {SearchDataTable,FilterSearchBilling,FormatedPrice} from '@gull'
import axios from 'axios';
import swal from "sweetalert2";
import { IsAuthContext } from 'app/App';

const useLoad = (initFilter,reload) => {
    const t = useTranslate()
    const { authParam } = useContext(IsAuthContext);
    const [validButton,setValidButton]=useState(false)
    const [company,setCompany] = useState(false)
    const [exportParam,setExportParam]=useState(initFilter) 
    const [perPage,setPerPage] = useState(50)
    const [currentPage,setCurrentPage] = useState(1)
    const [allDocuments,setAllDocuments] = useState([]) 
    const [constAdditionnalDatas,setConstAdditionnalDatas] = useState(false) 
    const [sizeDatas,setSizeDatas]=useState(0)
    const [clientId,setClientId]=useState((initFilter.client) ? initFilter.client : false)

    const currentDate = new Date();
    const lastYearDate = new Date();
    lastYearDate.setFullYear(currentDate.getFullYear() - 1);
    const [loadingTable,setLoadingTable] = useState(true)

    function formatDate(date) {
        var year = date.getFullYear();
        var month = String(date.getMonth() + 1).padStart(2, '0');
        var day = String(date.getDate()).padStart(2, '0');
        return year + '-' + month + '-' + day;
    }

    useEffect(function () {
        (async function() {
            if(reload){
                const response = await axios.get(process.env.REACT_APP_API_URL+"api/company/"+authParam.company.id
                ).then((response) => {
                    setCompany(response.data)
                }).catch((error) => {
                    if(error=='end_session') return;
                    let errorName = (error.response==undefined) ? 'unknowError' : (error.response.status==403) ? 'forbiddenGeneral' : 'unknowError'
                    swal.fire(t(errorName), "", "error");
                    setCompany({})
                })
            }
        })()
    }, [reload])

    useEffect(function () {
        (async function() {
            if(reload){
                setLoadingTable(true)
                setValidButton(true)
                const response = await axios.post(process.env.REACT_APP_API_URL+"api/facture/invoice/get_all/"+perPage+"/"+currentPage, exportParam
                ).then((response) => {
                    if(!response.data.valid){
                        let interms='';
                        var keys = Object.keys(response.data.errors);
                        for(var i = 0; i < keys.length; i++){
                            interms+=response.data.errors[keys[i]].join(',')+','
                        }
                        interms=interms.split(',')
                        let messageError='';
                        interms.forEach(interm=>messageError+=t(interm)+'. ')
                        messageError=messageError.replace('undefined','');
                        swal.fire(messageError, "", "error");
                    }
                    else{   
                        setAllDocuments(response.data.datas)
                        setConstAdditionnalDatas(response.data.additionnal_datas)
                        setSizeDatas(response.data.count)
                    }
                    setLoadingTable(false)
                }).catch((error) => {
                    if(error=='end_session') return;
                    let errorName = (error.response==undefined) ? 'unknowError' : (error.response.status==403) ? 'forbiddenGeneral' : 'unknowError'
                    swal.fire(t(errorName), "", "error");
                    setLoadingTable(false)
                })
                setValidButton(false)
            }
        })()
    }, [initFilter,reload])

    return [validButton,company,setExportParam,perPage,setPerPage,setCurrentPage,allDocuments,sizeDatas,currentDate,lastYearDate,formatDate,setSizeDatas,setAllDocuments,exportParam,currentPage,loadingTable,constAdditionnalDatas,setClientId,clientId]
}

const DocumentsB2b = (props) => {
    const t = useTranslate()
    const { authParam } = useContext(IsAuthContext);
    const [validButton,company,setExportParam,perPage,setPerPage,setCurrentPage,allDocuments,sizeDatas,currentDate,lastYearDate,formatDate,setSizeDatas,setAllDocuments,exportParam,currentPage,loadingTable,constAdditionnalDatas,setClientId,clientId]=useLoad(props.initFilter,props.reload)

    let devise = authParam.company.devise;
    let digit = (authParam.company.advanceparams.hasOwnProperty('ventilation_espece') && authParam.company.advanceparams.ventilation_espece.piece.find(piece=> +piece < 1)) ? 2 : 0;

    useEffect(() => {
        if(props.reload){
            setExportParam({
                ...exportParam,
                client: clientId
            });
            props.setReload(Date.now())
        }
    }, [clientId]);

    return (<>
         <div className="row">
            {(props.showFilter) &&
                <div className="col-12">
                    <FilterSearchBilling
                        validButton={validButton}
                        sevenDaysAgoFormated={formatDate(lastYearDate)}
                        todayFormated={formatDate(currentDate)}
                        company={company}
                        defaultClientId={props.clientId}
                        defaultEntreprise={props.initFilter?.other_company ?? ''}
                        setExportParam={setExportParam}
                        setReload={props.setReload}
                        defaultType=''
                        disabled={true}
                        setCurrentPage={setCurrentPage}
                    />
                </div>  
            }
            <div className="col-12">
                <SearchDataTable 
                    allDocuments={allDocuments}
                    sizeDatas={sizeDatas}
                    setPerPage={setPerPage}
                    perPage={perPage}
                    setSizeDatas={setSizeDatas}
                    setAllDocuments={setAllDocuments}
                    setCurrentPage={setCurrentPage}
                    exportParam={exportParam}
                    currentPage={currentPage}
                    header={(!constAdditionnalDatas) ? props.header : <>{props.header} <FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={constAdditionnalDatas} /></>}
                    setReload={props.setReload}
                    reload={props.reload}
                    loadingTable={loadingTable}
                    clientSearch={(props.showFilter || props.initFilter?.client) ? false : true}
                    setClientId={setClientId}
                />
            </div>    
        </div>          
    </>);
}

export default DocumentsB2b;
